/* eslint-disable */
import { produce } from "immer";
import {
  COUNTRY_FETCH_START,
  COUNTRY_FETCH_SUCCESS,
  COUNTRY_FETCH_FAILURE,
} from "../actions/types";

const getCountriesReducer = (
  state = {
    countryFetching: false,
    countryData: [],
    countryError: null,
  },
  action,
) => {
  switch (action.type) {
    case COUNTRY_FETCH_START:
      return produce(state, (draft) => {
        draft.countryFetching = true;
      });
    case COUNTRY_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.countryFetching = true;
        draft.countryData = action.data;
        draft.countryFetching = false;
      });
    case COUNTRY_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.countryFetching = false;
        draft.countryError = action.error;
      });
    default:
      return state;
  }
};

export default getCountriesReducer;
